import React, { useRef, useEffect, useState } from 'react';
import './scss/Home.scss';
import { Link } from 'react-router-dom';
import Logo, { LogoLight } from '../components/Sidebar/Logo';
import { useTheme } from '../context/ThemeContext';
import { config } from '../config';

const Contact = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark' || theme === 'system';
  const nameRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null

  useEffect(() => {
    // Autofocus name field for landing page forms
    nameRef.current?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const form = new FormData(e.currentTarget);
    const formData = {
      name: form.get('name'),
      email: form.get('email'),
      message: form.get('message')
    };

    try {
      const response = await fetch(`${config.API_URI}/v1/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSubmitStatus('success');
        // Reset form
        e.target.reset();
      } else {
        setSubmitStatus('error');
        console.error('Contact form error:', result.error);
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Contact form submission failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-page">
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-logo">
            {isDark ? <Logo width="120px" /> : <LogoLight width="120px" />}
          </div>
          <div className="nav-links">
            <Link to="/">Home</Link>
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
          </div>
          <div className="nav-actions">
            <Link to="/login" className="nav-login">Log In</Link>
            <Link to="/signup" className="nav-signup">Get Started Free</Link>
          </div>
        </div>
      </nav>

      <section className="features" style={{ paddingTop: '8rem' }}>
        <div className="container">
          <div className="section-header">
            <h2>Contact Us</h2>
            <p>We’d love to hear from you. Questions, feedback, or partnerships — reach out.</p>
          </div>

          <form onSubmit={handleSubmit} style={{ maxWidth: 560, margin: '0 auto' }}>
            {/* Status Messages */}
            {submitStatus === 'success' && (
              <div style={{
                background: '#d1fae5',
                border: '1px solid #10b981',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem',
                color: '#065f46',
                textAlign: 'center'
              }}>
                ✅ Thank you for your message! We'll get back to you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div style={{
                background: '#fee2e2',
                border: '1px solid #ef4444',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem',
                color: '#991b1b',
                textAlign: 'center'
              }}>
                ❌ Failed to send message. Please try again or email us directly at support@zoobbe.com
              </div>
            )}

            <div style={{ display: 'grid', gap: '1rem' }}>
              <input
                ref={nameRef}
                type="text"
                name="name"
                placeholder="Your name"
                required
                disabled={isSubmitting}
                className="hero__email-input"
                aria-label="Your name"
              />
              <input
                type="email"
                name="email"
                placeholder="Your email"
                required
                disabled={isSubmitting}
                className="hero__email-input"
                aria-label="Your email"
              />
              <textarea
                name="message"
                placeholder="How can we help?"
                required
                rows={5}
                disabled={isSubmitting}
                className="hero__email-input"
                aria-label="Your message"
                style={{ resize: 'vertical', paddingTop: '0.75rem' }}
              />
              <button
                type="submit"
                className="hero__signup-btn"
                style={{ width: '100%' }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
              <p className="hero__note" style={{ textAlign: 'center' }}>
                Or email us directly: <a href="mailto:support@zoobbe.com">support@zoobbe.com</a>
              </p>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;

